@if(!isLandingPage){
<div class="summary-list" [class.highlighted]="isHighlighted">
    @if (data.name && data.name !== 'Discounts & Surcharges' && data.name !== 'Valuables') {
    <h4>{{ data.name }}</h4>
    } @if (data.name === 'Billing information') {
    <div class="billing-header"></div>
    } @for (field of data.options.optionsList; track field; let i = $index; let first = $first; let last = $last) {
    <div class="d-flex flex-row psic-py-7">
        <div class="col-5 align-items-center">
            <div class="d-flex flex-column align-items-start w-180 py-2">
                <div class="d-flex flex-col pl-1">
                    @if (field.iconPath) {
                    <!-- <img
                        class="main-icon"
                        style="width: 64px; height: 64px; margin-right: 20px"
                        src="../../../assets/images/{{ field.iconPath }}.svg"
                        alt="..."
                    /> -->
                    <mat-icon
                        class="main-icon"
                        style="width: 64px; height: 64px; margin-right: 20px"
                        [svgIcon]="field.iconPath"
                    >
                    </mat-icon>

                    }
                </div>
                <div class="d-flex flex-column flex-fill">
                    <h6>{{ field.fieldName }}</h6>
                </div>
            </div>
        </div>
        <div class="col-7">
            @if (data.name === 'Discounts & Surcharges' && first) {
            <div class="d-flex flex-row flex-grow-1 row_cap_value py-2">
                <div class="col-4 acc-label caption-bold">DISCOUNT NAME</div>
                <div class="col-4 acc-label caption-bold text-end">APPLICABLE</div>
                <div class="col-4 acc-label caption-bold text-end">PREMIUM</div>
            </div>
            } @if (data.name === 'Valuables' && first) {
            <div class="d-flex flex-row flex-grow-1 row_cap_value py-2">
                <div class="col-4 acc-label caption-bold">VALUABLES NAME</div>
                <div class="col-4 acc-label caption-bold text-end">LIMIT</div>
                <div class="col-4 acc-label caption-bold text-end">PREMIUM</div>
            </div>
            } @else if (data.name === 'Coverages' ) {
            <div class="d-flex flex-row flex-grow-1 row_cap_value py-2">
                <div class="col-4 acc-label caption-bold">COVERAGE NAME</div>
                <div class="col-4 acc-label caption-bold text-end">LIMIT</div>
                <div class="col-4 acc-label caption-bold text-end">PREMIUM</div>
            </div>
            } @else if (data.name === 'Claims') {
            <div class="d-flex flex-row flex-grow-1 row_cap_value py-2">
                <div class="col-6 acc-label caption-bold">Claim ({{ i + 1 }})</div>
            </div>
            } @for (item of field.fieldList; track item; let i = $index; let first = $first; let last = $last) {
            <div>
                @if (!field.collapse || i < 3) {
                <div>
                    @switch (item.type) { @case ('cell_row_cap_value') {
                    <div>
                        <div class="d-flex flex-row flex-grow-1 row_cap_value py-2">
                            <div class="col-6 labelDetails">
                                <div class="box d-flex align-items-center">
                                    <div class="acc-label caption-bold" style="position: relative">
                                        {{ item.caption }}&nbsp;&nbsp;&nbsp;&nbsp; @if (item.helpText) {
                                        <mat-icon
                                            [svgIcon]="'img-help'"
                                            style="cursor: pointer; transform: translate(-7px, 2px); position: absolute"
                                            (click)="onHelpIconClick(item)"
                                        ></mat-icon>
                                        <!-- <img
                                            src="../../../assets/images/help-icon-sm.svg"
                                            alt="img-help"
                                            style="cursor: pointer; transform: translate(-7px, 2px); position: absolute"
                                            (click)="onHelpIconClick(item)"
                                        /> -->
                                        }
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 caption text-end valueDetails d-flex justify-content-end">
                                {{ item.value }}
                            </div>
                        </div>
                    </div>
                    } @case ('cell_row_bold_description_value') {
                    <div>
                        <div class="d-flex flex-row flex-grow-1 row_cap_value py-2">
                            <div class="col-6 labelDetails d-flex align-items-center">
                                <div class="box d-flex align-items-center">
                                    <div class="acc-label caption-bold" style="position: relative">
                                        {{ item.caption }}&nbsp;&nbsp;&nbsp;&nbsp; @if (item.helpText) {
                                        <mat-icon
                                            [svgIcon]="'img-help'"
                                            style="cursor: pointer; transform: translate(-7px, 2px); position: absolute"
                                            (click)="onHelpIconClick(item)"
                                        ></mat-icon>
                                        <!-- <img
                                            src="../../../assets/images/help-icon-sm.svg"
                                            alt="img-help"
                                            style="cursor: pointer; transform: translate(-7px, 2px); position: absolute"
                                            (click)="onHelpIconClick(item)"
                                        /> -->
                                        }
                                    </div>
                                </div>
                            </div>
                            <div
                                class="col-6 caption-bold text-end valueDetails d-flex flex-column justify-content-between"
                            >
                                <p class="text-end disclaimer-bold fs-3">{{ item.value }}</p>
                                <div [innerHTML]="item.description"></div>
                            </div>
                        </div>
                    </div>
                    } @case ('cell_row_description_value') {
                    <div>
                        <div class="d-flex flex-row flex-grow-1 row_cap_value py-2">
                            <div class="col-6 labelDetails">
                                <div class="box d-flex align-items-center">
                                    <div class="acc-label caption-bold" style="position: relative">
                                        {{ item.caption }}&nbsp;&nbsp;&nbsp;&nbsp; @if (item.helpText) {
                                        <mat-icon
                                            [svgIcon]="'img-help'"
                                            style="cursor: pointer; transform: translate(-7px, 2px); position: absolute"
                                            (click)="onHelpIconClick(item)"
                                        ></mat-icon>
                                        <!-- <img
                                            src="../../../assets/images/help-icon-sm.svg"
                                            alt="img-help"
                                            style="cursor: pointer; transform: translate(-7px, 2px); position: absolute"
                                            (click)="onHelpIconClick(item)"
                                        /> -->
                                        }
                                    </div>
                                </div>
                            </div>
                            <div
                                class="col-6 caption-bold text-end valueDetails d-flex flex-column justify-content-between"
                            >
                                {{ item.value }}
                                <div [innerHTML]="item.description"></div>
                            </div>
                        </div>
                    </div>
                    } @case ('highlight_row_cap_value') {
                    <div>
                        <div class="d-flex flex-row my-4">
                            <div class="flex-column flex-fill">
                                <div class="caption-bold p3-60-color">
                                    {{ item.caption }}
                                </div>
                            </div>
                            <div class="flex-column flex-fill">
                                <div class="caption-bold p3-60-color text-end valueDetails d-flex justify-content-end">
                                    {{ item.value }}
                                </div>
                            </div>
                        </div>
                    </div>
                    } @case ('highlight_row_display_msg') {
                    <div>
                        <div class="d-flex flex-row my-4">
                            <div class="flex-column flex-fill">
                                <div class="caption-bold p3-60-color">
                                    {{ item.caption }}
                                </div>
                            </div>
                        </div>
                    </div>
                    } @case ('cell_row_description_img_value') {
                    <div>
                        <div class="d-flex flex-row flex-grow-1 row_cap_value py-2">
                            <div class="col-6 labelDetails">
                                <div class="box d-flex align-items-center">
                                    <div class="acc-label d-flex flex-column caption-bold" style="position: relative">
                                        {{ item.caption }}&nbsp;&nbsp;&nbsp;&nbsp;
                                        <div [innerHTML]="item.description"></div>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="col-6 caption text-end valueDetails d-flex justify-content-end align-items-center"
                            >
                                <mat-icon [svgIcon]="item.iconPath" style="width: 47px; height: 32px; font-size: 47px">
                                </mat-icon>

                                <!-- <img
                                                            src="../../../assets/images/{{ item.iconPath }}.svg"
                                                            alt="card-icon"
                                                            style="width: 47px; height: 32px"
                                                        /> -->
                            </div>
                        </div>
                    </div>
                    } @case ('cell_row_img_value') {
                    <div>
                        <div class="d-flex flex-row flex-grow-1 row_cap_value py-2">
                            <div class="col-6 labelDetails">
                                <div class="box d-flex align-items-center">
                                    <div class="acc-label d-flex flex-column caption-bold" style="position: relative">
                                        {{ item.caption }}&nbsp;&nbsp;&nbsp;&nbsp;
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 caption text-end valueDetails d-flex justify-content-end">
                                <mat-icon
                                    [svgIcon]="item.value"
                                    style="
                                        display: block;
                                        flex-shrink: 0;
                                        overflow: visible;
                                        width: 48px;
                                        height: 48px;
                                        font-size: 48px;
                                    "
                                ></mat-icon>
                                <!-- <img src="../../../assets/images/{{ item.value }}.svg" alt="{{ iconPath }} logo" /> -->
                            </div>
                        </div>
                    </div>
                    } @case ('cell_row_tag_value') {
                    <div>
                        <div class="d-flex flex-row flex-grow-1 row_cap_value py-2">
                            <div class="col-6 labelDetails">
                                <div class="box d-flex align-items-center">
                                    <div class="acc-label caption-bold d-flex align-items-center">
                                        {{ item.caption }} @if (item.helpText) {
                                        <mat-icon
                                            [svgIcon]="'img-help'"
                                            style="cursor: pointer; transform: translate(-7px, 2px); position: absolute"
                                            (click)="onHelpIconClick(item)"
                                        ></mat-icon>
                                        <!-- <img
                                                                    src="../../../assets/images/help-icon-sm.svg"
                                                                    alt="img-help"
                                                                    style="cursor: pointer; margin-left: 8px"
                                                                    (click)="onHelpIconClick(item)"
                                                                /> -->
                                        }
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 caption text-end valueDetails d-flex justify-content-end">
                                <lib-tag
                                    [tagText]="item.value === 'InForce' ? 'In force' : item.value"
                                    [tagTheme]="item.tagTheme"
                                    [tagType]="'lineFill'"
                                ></lib-tag>
                            </div>
                        </div>
                    </div>
                    } @case ('cell_row_cap_value_premium') {
                    <div>
                        <div class="d-flex flex-row flex-grow-1 row_cap_value py-2">
                            <div class="col-4 labelDetails">
                                <div class="box d-flex align-items-center">
                                    <div class="acc-label caption-bold" style="position: relative">
                                        {{ item.caption }}&nbsp;&nbsp;&nbsp;&nbsp; @if (item.helpText) {
                                        <mat-icon
                                            [svgIcon]="'img-help'"
                                            style="cursor: pointer; transform: translate(-7px, 2px); position: absolute"
                                            (click)="onHelpIconClick(item)"
                                        ></mat-icon>
                                        <!-- <img
                                                                    src="../../../assets/images/help-icon-sm.svg"
                                                                    alt="img-help"
                                                                    style="cursor: pointer; transform: translate(-7px, 2px); position: absolute"
                                                                    (click)="onHelpIconClick(item)"
                                                                /> -->
                                        }
                                    </div>
                                </div>
                            </div>
                            <div class="col-4 caption text-end valueDetails d-flex justify-content-end">
                                {{ item.value }}
                            </div>
                            <div class="col-4 caption text-end valueDetails d-flex justify-content-end">
                                {{ item.premium }}
                            </div>
                        </div>
                    </div>
                    } @case ('cell_row_2col_premium') {
                    <div>
                        <div class="d-flex flex-row flex-grow-1 row_cap_value py-2">
                            <div class="col-6 labelDetails">
                                <div class="box d-flex align-items-center">
                                    <div class="acc-label caption-bold">
                                        {{ item.caption }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 caption text-end valueDetails d-flex justify-content-end">
                                {{ item.premium }}
                            </div>
                        </div>
                    </div>
                    } }
                </div>
                }
            </div>
            } @if (field.collapse && field.fieldList.length > 2) {
            <div class="py-2 cursor-pointer" (click)="toggleCollapse(field)">
                <!-- Collapsed content -->
                <div class="collapse-content" [class.open]="field.isOpen" [class.closed]="!field.isOpen">
                    @for (item of field.fieldList; track item; let i = $index; let first = $first; let last = $last) {
                    @if (i >= 1) { @switch (item.type) { @case ('table_row_cap_value') { @if (i === 2 &&
                    field.fieldList.length > 3) {
                    <div class="d-flex flex-row border-bottom flex-grow-1 row_cap_value py-2">
                        <div class="col-6 labelDetails">
                            <div class="box d-flex align-items-center">
                                <div class="acc-label caption" style="position: relative">
                                    {{ item.caption }}&nbsp;&nbsp;&nbsp;&nbsp; @if (item.helpText) {
                                    <mat-icon
                                        [svgIcon]="'img-help'"
                                        style="cursor: pointer; transform: translate(-7px, 2px); position: absolute"
                                        (click)="onHelpIconClick(item)"
                                    ></mat-icon>
                                    <!-- <img
                                                    src="../../../assets/images/help-icon-sm.svg"
                                                    alt="img-help"
                                                    style="cursor: pointer; transform: translate(-7px, 2px); position: absolute"
                                                    (click)="onHelpIconClick(item)"
                                                /> -->
                                    }
                                </div>
                            </div>
                        </div>
                        <div class="col-6 caption-bold text-end valueDetails d-flex justify-content-end">
                            {{ item.value }}
                        </div>
                    </div>
                    } @if (!last && i !== 2) {
                    <div class="d-flex flex-row border-bottom flex-grow-1 row_cap_value py-2">
                        <div class="col-6 labelDetails">
                            <div class="box d-flex align-items-center">
                                <div class="acc-label caption" style="position: relative">
                                    {{ item.caption }}&nbsp;&nbsp;&nbsp;&nbsp; @if (item.helpText) {
                                    <mat-icon
                                        [svgIcon]="'img-help'"
                                        style="cursor: pointer; transform: translate(-7px, 2px); position: absolute"
                                        (click)="onHelpIconClick(item)"
                                    ></mat-icon>
                                    <!-- <img
                                                    src="../../../assets/images/help-icon-sm.svg"
                                                    alt="img-help"
                                                    style="cursor: pointer; transform: translate(-7px, 2px); position: absolute"
                                                    (click)="onHelpIconClick(item)"
                                                /> -->
                                    }
                                </div>
                            </div>
                        </div>
                        <div class="col-6 caption-bold text-end valueDetails d-flex justify-content-end">
                            {{ item.value }}
                        </div>
                    </div>
                    } @if (last) {
                    <div class="d-flex mb-2 flex-row border-bottom flex-grow-1 row_cap_value py-2">
                        <div class="col-6 labelDetails">
                            <div class="box d-flex align-items-center">
                                <div class="acc-label caption" style="position: relative">
                                    {{ item.caption }}&nbsp;&nbsp;&nbsp;&nbsp; @if (item.helpText) {
                                    <mat-icon
                                        [svgIcon]="'img-help'"
                                        style="cursor: pointer; transform: translate(-7px, 2px); position: absolute"
                                        (click)="onHelpIconClick(item)"
                                    ></mat-icon>
                                    <!-- <img
                                                    src="../../../assets/images/help-icon-sm.svg"
                                                    alt="img-help"
                                                    style="cursor: pointer; transform: translate(-7px, 2px); position: absolute"
                                                    (click)="onHelpIconClick(item)"
                                                /> -->
                                    }
                                </div>
                            </div>
                        </div>
                        <div class="col-6 caption-bold text-end valueDetails d-flex justify-content-end">
                            {{ item.value }}
                        </div>
                    </div>
                    } } @case ('cell_row_description_value') { @if (!last && i > 2) {
                    <div class="d-flex flex-row flex-grow-1 row_cap_value py-2">
                        <div class="col-6 labelDetails">
                            <div class="box d-flex align-items-center">
                                <div class="acc-label caption-bold" style="position: relative">
                                    {{ item.caption }}&nbsp;&nbsp;&nbsp;&nbsp; @if (item.helpText) {
                                    <mat-icon
                                        [svgIcon]="'img-help'"
                                        style="cursor: pointer; transform: translate(-7px, 2px); position: absolute"
                                        (click)="onHelpIconClick(item)"
                                    ></mat-icon>
                                    <!-- <img
                                                    src="../../../assets/images/help-icon-sm.svg"
                                                    alt="img-help"
                                                    style="cursor: pointer; transform: translate(-7px, 2px); position: absolute"
                                                    (click)="onHelpIconClick(item)"
                                                /> -->
                                    }
                                </div>
                            </div>
                        </div>
                        <div
                            class="col-6 caption-bold text-end valueDetails d-flex flex-column justify-content-between"
                        >
                            {{ item.value }}
                            <div [innerHTML]="item.description"></div>
                        </div>
                    </div>
                    } @if (last && i !== 1) {
                    <div class="d-flex flex-row flex-grow-1 row_cap_value py-2">
                        <div class="col-6 labelDetails">
                            <div class="box d-flex align-items-center">
                                <div class="acc-label caption-bold" style="position: relative">
                                    {{ item.caption }}&nbsp;&nbsp;&nbsp;&nbsp; @if (item.helpText) {
                                    <mat-icon
                                        [svgIcon]="'img-help'"
                                        style="cursor: pointer; transform: translate(-7px, 2px); position: absolute"
                                        (click)="onHelpIconClick(item)"
                                    ></mat-icon>
                                    <!-- <img
                                                    src="../../../assets/images/help-icon-sm.svg"
                                                    alt="img-help"
                                                    style="cursor: pointer; transform: translate(-7px, 2px); position: absolute"
                                                    (click)="onHelpIconClick(item)"
                                                /> -->
                                    }
                                </div>
                            </div>
                        </div>
                        <div
                            class="col-6 caption-bold text-end valueDetails d-flex flex-column justify-content-between"
                        >
                            {{ item.value }}
                            <div [innerHTML]="item.description"></div>
                        </div>
                    </div>
                    } } } } }
                </div>
                <div class="d-flex align-items-center">
                    <span class="accent caption-bold">
                        {{
                            field.isOpen
                                ? 'View less'
                                : field.fieldName === 'Payment frequency'
                                ? 'See payment schedule'
                                : 'View more'
                        }}
                    </span>
                    <mat-icon class="accent" [class.rotated]="field.isOpen" [svgIcon]="'chevron-down'"></mat-icon>
                </div>
            </div>
            }
        </div>
    </div>
    @if (!last) {
    <div class="border-lit-bottom"></div>
    } }
</div>
}
